import cx from 'classnames';
import { Location } from 'history';
import { AD_INTERSTITIAL_SKIP_NOW, AD_INTERSTITIAL_SKIP_seconds } from 'mk/autogenerated/translations/AdSlotInterstitial.e64a474270a42f6b58fb8447c4f8b48b'
import { hasAds, isAuthenticated } from 'mk/bazaar/common/userUtils';
import { blogsArticleUrl } from 'mk2/apps/blogs/urls';
import { counsellingsHomeUrl, counsellingsPostDetailUrl } from 'mk2/apps/counsellings/urls';
import { forumPostDetailUrl, forumUrl } from 'mk2/apps/forum/urls';
import { groupsGroupUrl, groupsPhotoDetailUrl, groupsPostDetailUrl } from 'mk2/apps/groups/urls';
import { heartsUrl } from 'mk2/apps/hearts/urls';
import { homepageUrl } from 'mk2/apps/home/urls';
import { mailUrl } from 'mk2/apps/mail/urls';
import { wallUrl } from 'mk2/apps/wall/urls';
import { wikiArticleUrl, wikiUrl } from 'mk2/apps/wiki/urls';
import Btn, { BtnType } from 'mk2/components/Btn';
import AdSlot from 'mk2/containers/AdSlot/AdSlot';
import {
    adSlotInterstitialConsumned,
    adSlotInterstitialLoadNext,
} from 'mk2/containers/AdSlotInterstitial/AdSlotInterstitial.actions';
import { AdSlotInterstialState } from 'mk2/containers/AdSlotInterstitial/AdSlotInterstitial.reducers';
import { getAdSlotInterstitialState } from 'mk2/containers/AdSlotInterstitial/AdSlotInterstitial.selectors';
import { Route } from 'mk2/containers/Application/Application';
import SiteMenu from 'mk2/containers/SiteMenu/SiteMenu';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { AppState } from 'mk2/reducers';
import { UserEntity } from 'mk2/schemas';
import { interpolate } from 'mk2/services/i18n';
import React from 'react';
import { connect } from 'react-redux';
import styles from './AdSlotInterstitial.mscss';

interface OwnProps {
    zone: string;
    location: Location;   // current location (url)
    route: Route;         // current route definition
    requestUser: UserEntity;
    requestUserPermissions: string[];
}

interface OwnState {
    hasInterstialAd: boolean;
    isPageTransition: boolean;
    closeCountDown: number;
}

interface StateProps {
    isAdLoaded: boolean;
}

interface DispatchProps {
    onConsumed();
    onLoadNext(slotId: string);
}

type Props = OwnProps & StateProps & DispatchProps;

class AdSlotInterstitial extends React.PureComponent<Props, OwnState> {

    // potrebujem len slotId, ale nie je este jednoduchy sposob ako sa k nemu dostat
    private adSlotRef = React.createRef<HTMLDivElement>();

    private countdownTimer = null;

    constructor(props: Props) {
        super(props);

        const { requestUser, requestUserPermissions } = props;

        this.state = {
            hasInterstialAd: isAuthenticated(requestUser) && hasAds(requestUser),
            isPageTransition: false,
            closeCountDown: 0,
        };
    }

    public componentWillReceiveProps(nextProps: Props) {
        if (!this.state.hasInterstialAd) {
            return;
        }

        if (this.props.location.pathname === nextProps.location.pathname) {
            // zostavame na tej istej url. T.j. zmenili sa v State stranky veci co nas nezaujimu,
            // alebo sa zmenili len GET parametre (napr. page=). Vtedy nechceme zobrazit reklamu.
            return;
        }

        const isTransitionToHomePage = nextProps.route.path === homepageUrl;
        const isTransitionToForumPage = nextProps.route.path.startsWith(forumUrl);
        const isTransitionToCounsellingPage = nextProps.route.path.startsWith(counsellingsHomeUrl);
        const isTransitionToBlogsPage = nextProps.route.path.startsWith(blogsArticleUrl);
        const isTransitionToGroupPage = nextProps.route.path.startsWith(groupsGroupUrl);
        const isTransitionToHeartsPage = nextProps.route.path.startsWith(heartsUrl);
        const isTransitionToWallPage = nextProps.route.path.startsWith(wallUrl);
        const isTransitionToMailPage = nextProps.route.path.startsWith(mailUrl);
        const isTransitionToWikiPage =
            nextProps.route.path.startsWith(wikiArticleUrl) ||
            nextProps.route.path.startsWith(wikiUrl);

        const isTranstionToPageWithAd =
            isTransitionToHomePage ||
            isTransitionToForumPage ||
            isTransitionToCounsellingPage ||
            isTransitionToBlogsPage ||
            isTransitionToGroupPage ||
            isTransitionToHeartsPage ||
            isTransitionToWallPage ||
            isTransitionToMailPage ||
            isTransitionToWikiPage;

        const newIsPageTransition = (
            this.props.route.path === homepageUrl ||                   // on HomePage
            this.props.route.path === forumPostDetailUrl ||            // on PostDetailPage
            this.props.route.path === counsellingsPostDetailUrl ||     // on CounsulellingsPostDetailPage
            this.props.route.path === blogsArticleUrl ||               // on BlogsArticlePage
            (this.props.route.path === groupsGroupUrl &&               // on GroupFeedPage
                nextProps.route.path !== groupsPostDetailUrl &&        // not going to GroupPostDetail
                nextProps.route.path !== groupsPhotoDetailUrl) ||      // not going to GroupPhotoDetail
            this.props.route.path === wikiArticleUrl                   // on WikiArticle
        ) && isTranstionToPageWithAd;                                  // going to other content

        if (this.state.isPageTransition !== newIsPageTransition) {
            if (newIsPageTransition) {
                window.setTimeout(this.handleCloseCountdownTick, 1000);
            }

            this.setState({
                isPageTransition: newIsPageTransition,
                closeCountDown: 5,
            });
        }
    }

    public componentWillUnmount() {
        if (!this.state.hasInterstialAd) {
            return;
        }

        if (this.countdownTimer) {
            window.clearTimeout(this.countdownTimer);
            this.countdownTimer = null;
        }
    }

    public render() {
        const { zone, children, isAdLoaded, location } = this.props;
        const { hasInterstialAd, isPageTransition, closeCountDown } = this.state;

        const showAd = isAdLoaded && isPageTransition;

        const closeBtn = showAd
            ? (
                <Btn
                    type={BtnType.Blue}
                    label={closeCountDown > 0
                        ? interpolate(AD_INTERSTITIAL_SKIP_seconds, {seconds: closeCountDown})
                        : AD_INTERSTITIAL_SKIP_NOW
                    }
                    onClick={this.handleOnAdClose}
                    disabled={closeCountDown > 0}
                />
            ) : null;

        return (
            /*
               daj key="..." v DOMe az po <AdSlot>, aby sa pri re-renderi nevyhodil z DOMu, pretoze obsahuje
               iframe s reklamou, ktory donho vlozil googletag a my sami ho nemame nevieme vyrobit.
            */
            <React.Fragment key="adslot-wrapper">
                {(!hasInterstialAd || !showAd) && (
                    // zobraz povodnu stranku, ktora by mala byt zobrazena, ak by sme nezobrazovali Interstitial ad.
                    // Nemozeme 'interstitial ad' nakreslit len nad povodnou stranku (napr. cez position: absolute),
                    // lebo AdManager ma pravidlo, ze reklamy (AdSlots) sa nesmu navzajom prekryvat. To podla vsetkeho
                    // povoluje len 'Premium' verzia AdManagera, ktoru ale nemame.
                    <React.Fragment>
                        {children}
                    </React.Fragment>
                )}

                {hasInterstialAd && (
                    <AdSlot
                        key="adslot"
                        className={cx(
                            styles.AdSlotInterstitial,
                            showAd ? styles['AdSlotInterstitial--show'] : styles['AdSlotInterstitial--hide'],
                        )}
                        zone={zone}
                        prefix="mk-interstitial"
                        slotRef={this.adSlotRef}
                    >
                        {/*
                            header je naschval zavrety vnutri AdSlotu, lebo nie sme v Page a musime si sami
                            robit layout stranky
                         */}
                        {showAd && (
                            <React.Fragment>
                                <SiteMenu
                                    menuSelection={null}
                                    fluxibleCompatibility={false}
                                    currentUrl={`${location.pathname}${location.search}`}
                                    headerHasBackBtn={false}
                                    headerTitle={null}
                                    headerLeft={null}
                                    headerRight={closeBtn}
                                    desktopHeaderRight={closeBtn ? (
                                        <div className={styles.AdSlotInterstitial__desktopRight}>
                                            {closeBtn}
                                        </div>
                                    ) : null}
                                    headerTabs={null}
                                    mobileShowLogo
                                    isHeaderSticky={false}
                                    disablePrivacyReminder
                                    disableToastr
                                    disableJam
                                    disableDesktopSectionTabs
                                    disableDesktopNotificationMenu
                                    disableMobileHamburger
                                    disableLogoLink
                                />
                            </React.Fragment>
                        )}
                    </AdSlot>
                )}
            </React.Fragment>
        );
    }

    private handleOnAdClose = () => {
        const { onConsumed, onLoadNext } = this.props;

        onConsumed();
        this.setState({
            isPageTransition: false,
        });

        // load next interstitial ad every 30sec.
        if (this.adSlotRef.current) {
            // Zvycajne je reklama velka (napr. obsahuje video).
            // Preto ju zobrazime az ked sa nacita
            onLoadNext(this.adSlotRef.current.id);
        }
    };

    private handleOnMenuClose = () => {
        this.setState({
            isPageTransition: false,
        });
    };

    private handleCloseCountdownTick = () => {
        const { closeCountDown } = this.state;

        if (closeCountDown > 0) {
            this.setState({
                closeCountDown: closeCountDown - 1,
            });
            window.setTimeout(this.handleCloseCountdownTick, 1000);
        }
    };
}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    const adState: AdSlotInterstialState = getAdSlotInterstitialState(state);

    return {
        isAdLoaded: adState.isLoaded,
    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
    onConsumed: adSlotInterstitialConsumned,
    onLoadNext: adSlotInterstitialLoadNext,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdSlotInterstitial);
